import { setDeviceTypes } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import { MultiselectFilter } from './MultiselectFilter';
import { DeviceType } from '@customer/store/apis/assetsApi';
import { useMemo } from 'react';
import { hardwareTypeFromDto } from '@cas/utils/translationHelpers';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';

// Remove "Unknown" from the enum before making the list of devices.
const DEVICE_TYPES: DeviceType[] = Object.values(DeviceType).slice(1);

const useDeviceTypeOptions = (): DropdownItemProps<DeviceType>[] => {
  return useMemo(() => {
    return DEVICE_TYPES.map((value: DeviceType) => {
      return {
        key: value,
        value,
        stringValue: value,
        label: hardwareTypeFromDto(value),
      };
    });
  }, []);
};

export const DeviceTypesFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();

  return (
    <MultiselectFilter<DeviceType>
      filterName="deviceTypes"
      label={label ?? t('DeviceType')}
      action={setDeviceTypes}
      elementRef={elementRef}
      useItemsHook={useDeviceTypeOptions}
    />
  );
};

export default DeviceTypesFilter;
